import { render } from "./AccountDetailsSettings.vue?vue&type=template&id=5f659004"
import script from "./AccountDetailsSettings.vue?vue&type=script&lang=js"
export * from "./AccountDetailsSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__